module.exports = __webpack_public_path__ + "img/faild.1922f11a.svg";